//import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";

const customAnmation = new CustomAnimation();

class Textpage {
  init() {
    this.initParallax();
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    $('.header_stoerer').addClass('hide');

    customAnmation.animateHeaderImage('.header');
    customAnmation.animateFromBottom('h2, h3, p, .button_holder');

  }
}

export default Textpage;
